module.exports = __webpack_public_path__ + "static/media/loginPersonal.599f9cd4.svg";